// extracted by mini-css-extract-plugin
export default {"newsfeed":"ZJ-z"};